import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/sdc/inscricao/page.tsx");
